import { dimensions } from '../helpers/dimensions';
import Debounce from 'debounce';
import DomUtils from '../helpers/dom-utils';

const isPDP = document.querySelector('.product-page') ? true : false;

const CONSTANTS = {
  breakpoints : {
    mobile : 768, // Anything less than 768px
    tablet : isPDP ? 1024 : 960 // Anything less than this, Desktop is anything equal to and greater than this
  },
  buttonClasses : {
    expand : 'button--expand',
    collapse : 'button--contract',
    toggleClass : 'swatch-list-toggle',
    button : 'button'
  },
  buttonText : {
    showMore : hiddenSwatchCount => { return hiddenSwatchCount === 1 ? `Show ${hiddenSwatchCount} more colour` :  `Show ${hiddenSwatchCount} more colours` },
    showLess : 'Show fewer colours'
  }
}

export class SwatchList {
  constructor(options) {

    if(this.checkForOptions(options)) {
      const CONTAINER = document.querySelector(options.containerClass);

      this.state = {
        container : CONTAINER,
        swatchItems : CONTAINER.querySelectorAll(options.itemClass),
        elemToCollapse : CONTAINER.querySelector(options.classToCollapse),
        maxVisibleSwatches : options.maxVisibleSwatches,
        maxInRow : options.maxInRow,
        hiddenSwatchCount : '',
        screenWidth       : document.documentElement.clientWidth,
        selectedSwatchPosition : null
      }

      this.addResizeListener();
      this.setupSwatches();
    }
  }

  checkForOptions(options) {
    const{
      maxVisibleSwatches,
      maxInRow,
      containerClass,
      itemClass,
      classToCollapse
    } = options

    if(maxVisibleSwatches && maxInRow && containerClass && itemClass && classToCollapse) {
      return true;
    } else {
      console.warn( `You're missing something :: maxVisibleSwatches: ${maxVisibleSwatches}, maxInRow: ${maxInRow}, containerClass: ${containerClass}, itemClass: ${itemClass}, classToCollapse: ${classToCollapse}` );
      return false;
    }
  }

  addResizeListener() {
    window.addEventListener('resize', Debounce(this.handleResize.bind(this), 200));
  }

  handleResize() {
    let screenWidth = document.documentElement.clientWidth;

    if( screenWidth !== this.state.screenWidth ) {
      this.state.screenWidth = screenWidth;
      this.setupSwatches();
    }
  }

  setSelectedSwatchPosition(swatchItems) {
    for(let i=0; i< swatchItems.length; i++) {
      if(swatchItems[i].querySelector('.swatch--current') || swatchItems[i].querySelector('.swatch--current-and-unavailable')) this.state.selectedSwatchPosition = i;
    }
    return this.state.selectedSwatchPosition;
  }

  setMaxVisibleSwatches(indexCorrectedSelectedSwatchPosition, deviceMaxVisibleSwatches, device) {
    if(indexCorrectedSelectedSwatchPosition > deviceMaxVisibleSwatches) {

      let numberInRow = swatchLayoutOptions.maxInRow[device];

      while(indexCorrectedSelectedSwatchPosition % numberInRow) {
        indexCorrectedSelectedSwatchPosition = indexCorrectedSelectedSwatchPosition + 1;
      }

      return indexCorrectedSelectedSwatchPosition;
    } else {
      return deviceMaxVisibleSwatches;
    }
  }

  hasHiddenSwatches(count, maxInRow, indexCorrectSelectedSwatchPosition) {
    if( count % maxInRow > 0 ) {
      if( indexCorrectSelectedSwatchPosition % maxInRow === 1 && count - indexCorrectSelectedSwatchPosition < maxInRow ) { // Specific last row logic
        return false;
      }
      return (count - indexCorrectSelectedSwatchPosition) > 0 ? true : false;
    } else {
      return (count - indexCorrectSelectedSwatchPosition) >= maxInRow ? true : false;
    }
  }

  setupSwatches() {
    const {
      swatchItems,
      maxVisibleSwatches,
      elemToCollapse,
    } = this.state;

    let selectedSwatchPosition = this.setSelectedSwatchPosition(swatchItems);
    let indexCorrectSelectedSwatchPosition = selectedSwatchPosition + 1;
    let winWidth = document.documentElement.clientWidth;
    let count = swatchItems.length;
    let toggleButton = document.querySelector(`.${CONSTANTS.buttonClasses.toggleClass}`);
    let device = this.checkDeviceType(winWidth);
    let maxInRow = this.setMaxInRow(device);
    let swatchHeight = dimensions.getElementHeight(swatchItems[0], false);
    let hasHiddenSwatches = this.hasHiddenSwatches(count, maxInRow, indexCorrectSelectedSwatchPosition);

    if( device === 'mobile' && count > maxVisibleSwatches.mobile ) {
      let visibleSwatches = this.setMaxVisibleSwatches( indexCorrectSelectedSwatchPosition, maxVisibleSwatches.mobile, device);
      this.createAccordion( visibleSwatches, maxInRow );
      if(!toggleButton && hasHiddenSwatches ) this.appendExpandButton();

    } else if ( device === 'tablet' && count > maxVisibleSwatches.tablet ) {
      let visibleSwatches = this.setMaxVisibleSwatches(indexCorrectSelectedSwatchPosition, maxVisibleSwatches.tablet, device);
      this.createAccordion( visibleSwatches, maxInRow );
      if(!toggleButton && hasHiddenSwatches) this.appendExpandButton();

    } else if ( device === 'desktop' && count > maxVisibleSwatches.desktop ) {
      let visibleSwatches = this.setMaxVisibleSwatches(indexCorrectSelectedSwatchPosition, maxVisibleSwatches.desktop, device);
      this.createAccordion( visibleSwatches, maxInRow );
      if(!toggleButton && hasHiddenSwatches) this.appendExpandButton();

    } else if (toggleButton) {
      this.setExpandedHeightInState(maxInRow, swatchHeight);
      elemToCollapse.setAttribute('style', `height: ${this.state.expandedHeight}px; overflow: initial;`);
      toggleButton.remove();

    } else {
      this.setExpandedHeightInState(maxInRow, swatchHeight);
      elemToCollapse.setAttribute('style', `height: ${this.state.expandedHeight}px; overflow: initial;`);
    }
  }

  checkDeviceType(winWidth) {
    if( winWidth < CONSTANTS.breakpoints.mobile ) {
      return 'mobile';
    } else if(winWidth >= CONSTANTS.breakpoints.mobile && winWidth < CONSTANTS.breakpoints.tablet) {
      return 'tablet';
    } else {
      return 'desktop';
    }
  }

  setMaxInRow(device) {
    const {
      maxInRow,
    } = this.state;

    if(device === 'mobile') {
      return maxInRow.mobile;
    } else if(device === 'tablet') {
      return maxInRow.tablet;
    } else {
      return maxInRow.desktop;
    }
  }

  createAccordion(maxSwatches, maxInRow) {
    const {
      swatchItems,
      elemToCollapse,
      container
    } = this.state

    let swatchHeight = dimensions.getElementHeight(swatchItems[0], false);
    let button = container.querySelector('button');

    this.setCollapsedHeightInState(maxInRow, maxSwatches, swatchHeight);
    this.setExpandedHeightInState(maxInRow, swatchHeight);

    this.state.hiddenSwatchCount = swatchItems.length - maxSwatches;

    elemToCollapse.setAttribute('style', `height: ${this.state.collapsedHeight}px; overflow: hidden;`);

    if(button) {
      this.updateButton(button)
    }

    this.setTabIndices(true);
  }

  setTabIndices(collapsed) {
    const {
      swatchItems,
      hiddenSwatchCount,
    } = this.state;

    const hideThreshold = collapsed ? swatchItems.length - (hiddenSwatchCount + 1) : swatchItems.length;

    swatchItems.forEach((item, index) => {
      const anchor = item.querySelector('a');
      if(index > hideThreshold) {
        anchor.setAttribute('tabindex', -1);
      } else {
        anchor.removeAttribute('tabindex');
      }
    });
  }

  setCollapsedHeightInState(maxInRow, maxSwatches, swatchHeight) {
    let collapsedRowCount = maxSwatches/maxInRow;
    let collapsedHeight = swatchHeight * collapsedRowCount;
    this.state.collapsedHeight = collapsedHeight;
  }

  setExpandedHeightInState(maxInRow, swatchHeight) {
    let expandedRowCount = this.calculateExpandedRowCount(maxInRow);
    let expandedHeight = expandedRowCount * swatchHeight;
    this.state.expandedHeight = expandedHeight;
  }

  calculateExpandedRowCount(maxInRow) {
    const {
      swatchItems
    } = this.state

    let count = swatchItems.length;
    let actual = count / maxInRow;
    return actual - parseInt(actual) > 0 ? parseInt(actual) + 1 : actual;
  }

  updateButton(button) {
    const {
      hiddenSwatchCount
    } = this.state

    button.classList.remove(CONSTANTS.buttonClasses.collapse);
    button.classList.add(CONSTANTS.buttonClasses.expand);
    button.innerText = CONSTANTS.buttonText.showMore(hiddenSwatchCount);
  }

  appendExpandButton() {
    const {
      container,
      hiddenSwatchCount,
    } = this.state;

    let button = document.createElement('button');
    DomUtils.addClass(button, CONSTANTS.buttonClasses.toggleClass);
    DomUtils.addClass(button, CONSTANTS.buttonClasses.expand);
    DomUtils.addClass(button, 'button');
    button.innerText = CONSTANTS.buttonText.showMore(hiddenSwatchCount);
    container.appendChild(button);

    button.addEventListener('click', this.toggleExpandButton.bind(this));
  }

  toggleExpandButton(event) {
    const {
      elemToCollapse,
      expandedHeight,
      collapsedHeight,
      hiddenSwatchCount,
    } = this.state;

    let elem = event.target;

    if (elem.classList.contains(CONSTANTS.buttonClasses.expand)) {
      elemToCollapse.setAttribute('style', `height: ${expandedHeight}px; overflow: hidden;`);
      elem.innerText = CONSTANTS.buttonText.showLess;
      elem.classList.remove(CONSTANTS.buttonClasses.expand);
      elem.classList.add(CONSTANTS.buttonClasses.collapse);
      this.setTabIndices(false);
    } else {
      elemToCollapse.setAttribute('style', `height: ${collapsedHeight}px; overflow: hidden;`);
      elem.innerText = CONSTANTS.buttonText.showMore(hiddenSwatchCount);
      elem.classList.remove(CONSTANTS.buttonClasses.collapse);
      elem.classList.add(CONSTANTS.buttonClasses.expand);
      this.setTabIndices(true);
    }
  }
}

const initChanelPageSwatches = () => {
  let options = {
    containerClass : '.swatch-list-section',
    itemClass : '.swatch-list-item',
    classToCollapse : '.swatch-list',
    maxVisibleSwatches : {
      mobile: 10,
      tablet: 9,
      desktop : 9
    },
    maxInRow : {
      mobile: 2,
      tablet: 3,
      desktop : 3
    }
  }
  new SwatchList(options);
}

const swatchLayoutOptions = {
  containerClass : '.swatch-list-section',
  itemClass : '.swatch-list-item',
  classToCollapse : '.swatch-list',
  maxVisibleSwatches : {
    mobile: 10,
    tablet: 9,
    desktop : 9
  },
  maxInRow : {
    mobile: 2,
    tablet: 3,
    desktop : 3
  }
}

const initProductPageSwatches = () => {
  swatchLayoutOptions.maxInRow.tablet = 2;
  swatchLayoutOptions.maxInRow.desktop = isPDP ? 3 : 2;
  swatchLayoutOptions.maxVisibleSwatches.tablet = isPDP ? 8 : 9;
  new SwatchList(swatchLayoutOptions);
}

const arePresent = () => {
  return document.querySelector('.swatch-list-section');
}

export default {
  initChanelPageSwatches,
  initProductPageSwatches,
  arePresent
}
